import React from "react";
import {
    Card,
    CardBody,
    CardHeader,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    UncontrolledDropdown,
} from "reactstrap";
import ReactApexChart from "react-apexcharts";

const OrderReportEfficiency = () => {
    var options : any = {
        chart: {
            height: 350,
            type: "bar",
            toolbar: { show: false }
        },
        plotOptions: {
            bar: {
                columnWidth: "50%", // Độ rộng cột
                dataLabels: {
                    position: "top", // top, center, bottom
                },
            }
        },
        dataLabels: {
            enabled: true, // Bật hiển thị giá trị
            style: {
                fontSize: "12px",
                colors: ["#adb5bd"],
            },
            offsetY: -20 // Điều chỉnh vị trí chữ trên đỉnh cột
        },
        xaxis: {
            type: "category", // Apex tự nhận từ `x`
            labels: { rotate: -45 } // Xoay nhãn để dễ đọc
        },
        colors: ["#007bff"], // Màu duy nhất (blue)
        legend: { show: false }
    };

    // Biết được các khoàng thời gian xử lý và số lượng đơn hàng tương ứng trong khoảng thời gian đó (thời gian xử lý = bắt đầu làm - thanh toán thành công)
    const series = [{
        name: "Thời gian xử lý",
        data: [{
            x: '0-1 phút',
            y: 5
        }, {
            x: '1-2 phút',
            y: 5
        }, {
            x: '2-3 phút',
            y: 10
        }, {
            x: '3-4 phút',
            y: 20
        }, {
            x: '4-5 phút',
            y: 30
        }, {
            x: '5-6 phút',
            y: 50
        }, {
            x: '6-7 phút',
            y: 70
        }, {
            x: '7-8 phút',
            y: 50
        }, {
            x: '8-9 phút',
            y: 40
        }, {
            x: '9-10 phút',
            y: 30
        }, {
            x: '10-11 phút',
            y: 20
        }, {
            x: '11-12 phút',
            y: 15
        }, {
            x: '12-13 phút',
            y: 10
        }, {
            x: '13-14 phút',
            y: 10
        }, {
            x: '14-15 phút',
            y: 5
        }]
    }];

    // Biết được vào thời gian xử lý trung bình của đơn hàng trong khung giờ tương ứng (thời gian xử lý = bắt đầu làm - thanh toán thành công)
    const series1 = [{
        name: "Thời gian xử lý",
        data: [{
            x: '0h-1h',
            y: 5
        }, {
            x: '1h-2h',
            y: 5
        }, {
            x: '2h-3h',
            y: 10
        }, {
            x: '3h-4h',
            y: 20
        }, {
            x: '4h-5h',
            y: 30
        }, {
            x: '5h-6h',
            y: 50
        }, {
            x: '6h-7h',
            y: 70
        }, {
            x: '7h-8h',
            y: 50
        }, {
            x: '8h-9h',
            y: 40
        }, {
            x: '9h-10h',
            y: 30
        }, {
            x: '10h-11h',
            y: 20
        }, {
            x: '11h-12h',
            y: 15
        }, {
            x: '12h-13h',
            y: 10
        }, {
            x: '13h-14h',
            y: 10
        }, {
            x: '14h-15h',
            y: 5
        }, {
            x: '15h-16h',
            y: 5
        }, {
            x: '16h-17h',
            y: 10
        }, {
            x: '17h-18h',
            y: 20
        }, {
            x: '18h-19h',
            y: 30
        }, {
            x: '19h-20h',
            y: 50
        }, {
            x: '20h-21h',
            y: 70
        }, {
            x: '21h-22h',
            y: 50
        }, {
            x: '22h-23h',
            y: 40
        }, {
            x: '23h-24h',
            y: 30
        }]
    }];

    return (
        <React.Fragment>
            <div className="page-content-wrapper py-3">
                <div className="container">
                    <Card>
                        <CardHeader>
                            <div className="d-flex">
                                <h5 className="card-title mb-0 flex-grow-1  ">Thời gian xử lý</h5>
                                <div className="flex-shrink-0">
                                    <UncontrolledDropdown className="card-header-dropdown">
                                        <DropdownToggle
                                            className="text-reset dropdown-btn"
                                            tag="a"
                                            type="a"
                                            to="#"
                                        >
                                            <span className="fw-semibold text-uppercase fs-12">
                                              Lọc theo:{" "}
                                            </span>
                                            <span className="text-muted">
                                          Tuần này
                                          <i className="mdi mdi-chevron-down ms-1"></i>
                                        </span>
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-end">
                                            <DropdownItem href="#">Hôm nay</DropdownItem>
                                            <DropdownItem href="#">Tuần này</DropdownItem>
                                            <DropdownItem href="#">Tuần trước</DropdownItem>
                                            <DropdownItem href="#">7 ngày qua</DropdownItem>
                                            <DropdownItem href="#">Tháng này</DropdownItem>
                                            <DropdownItem href="#">Tháng trước</DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <ReactApexChart
                                dir="ltr"
                                className="apex-charts"
                                series={series}
                                options={options}
                                type="bar"
                                height={350}
                            />
                        </CardBody>
                    </Card>
                    <Card className={"mt-2"}>
                        <CardHeader>
                            <div className="d-flex">
                                <h5 className="card-title mb-0 flex-grow-1  ">Thời gian xử lý</h5>
                                <div className="flex-shrink-0">
                                    <UncontrolledDropdown className="card-header-dropdown">
                                        <DropdownToggle
                                            className="text-reset dropdown-btn"
                                            tag="a"
                                            type="a"
                                            to="#"
                                        >
                                            <span className="fw-semibold text-uppercase fs-12">
                                              Lọc theo:{" "}
                                            </span>
                                            <span className="text-muted">
                                          Tuần này
                                          <i className="mdi mdi-chevron-down ms-1"></i>
                                        </span>
                                        </DropdownToggle>
                                        <DropdownMenu className="dropdown-menu-end">
                                            <DropdownItem href="#">Hôm nay</DropdownItem>
                                            <DropdownItem href="#">Tuần này</DropdownItem>
                                            <DropdownItem href="#">Tuần trước</DropdownItem>
                                            <DropdownItem href="#">7 ngày qua</DropdownItem>
                                            <DropdownItem href="#">Tháng này</DropdownItem>
                                            <DropdownItem href="#">Tháng trước</DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </div>
                            </div>
                        </CardHeader>
                        <CardBody>
                            <ReactApexChart
                                dir="ltr"
                                className="apex-charts"
                                series={series1}
                                options={options}
                                type="bar"
                                height={350}
                            />
                        </CardBody>
                    </Card>
                </div>
            </div>
        </React.Fragment>
    );
};

export default OrderReportEfficiency;
